import styled from "styled-components";

export const ClampedText = styled.span<{ $maxRows: number }>`
    overflow: hidden;
    display: -webkit-box;
    -webkit-box-orient: vertical;

    -webkit-line-clamp: ${({ $maxRows }) => $maxRows};
    line-clamp: ${({ $maxRows }) => $maxRows};

    word-break: break-word;
    text-overflow: ellipsis;
`;
